// extracted by mini-css-extract-plugin
module.exports = {"avatar":"img_avatar__229Dj","avatar__status":"img_avatar__status__33-3L","avatar__speed":"img_avatar__speed__3Zvlh"};